import React from "react";

export default function MainListView(props) {
  return (
    <div className="Main-list-view">
      <div className={props.listType + "-items-container"}>{props.body()}</div>
      {props.footer}
    </div>
  );
}
